
































































import Vue from "vue";
import { Controllers } from "@infoland/iprova-api";
import storeHelper from "@/store/store-helper";
import i18n from "@/plugins/i18n";
import * as UAS from "@/userapplicationstate";
import Utils from "@/utils";

interface ApiCampaignGet {
    campaign_id: string;
    chance: number;
    response_limit?: number;
    start_date: string;
    question: string;
    shown: boolean;
    responded: boolean;
    number_of_responses: number;
}

interface ApiCampaignResultPost {
    score: number;
    reaction: string;
}

export default Vue.extend({
    name: "CampaignFeedback",
    props: {
        campaignId: String
    },
    data: function () {
        return {
            showFeedback: false as boolean,
            feedbackSent: false as boolean,
            rating: null as number,
            reaction: "" as string,
            question: "" as string
        };
    },
    computed: {
        showTextbox(): boolean {
            return this.rating !== null;
        },
        followUpQuestion(): any {
            if (this.rating <= 2) {
                return i18n.t("campaign.followUpRatingLow");
            } else {
                return i18n.t("campaign.followUpRatingHigh");
            }
        }
    },
    watch: {
        campaignId: {
            immediate: true,
            handler(newValue: string) {
                if (!newValue) {
                    this.close();

                    return;
                }

                if (Utils.isAnonymousUser(this.$user.user_id)) return;

                //start loading campaign
                this.getCampaign();
            }
        }
    },
    methods: {
        async getCampaign() {
            //call API
            const campaignInfo = await Controllers.GenericController.getAsync<ApiCampaignGet>(`campaigns/${this.campaignId}/`);

            //checks to see if campaign must be shown
            if (!campaignInfo) return; //campaign not found
            if (campaignInfo.shown) return;
            if (campaignInfo.responded) return;
            if (campaignInfo.start_date.toDate() > new Date()) return; // not active yet
            if (campaignInfo.response_limit !== undefined && campaignInfo.response_limit <= campaignInfo.number_of_responses) return;

            //Use random to apply change factor
            this.question = campaignInfo.question;

            if (Math.random() < campaignInfo.chance) {
                this.showFeedback = true;
                this.setShown();
            }
        },

        async send() {
            const campaignResultId: string = await Controllers.GenericController.postAsync<ApiCampaignResultPost, string>(
                `campaigns/${this.campaignId}/campaign_results/`,
                {
                    score: this.rating,
                    reaction: this.reaction.trim()
                }
            );

            if (campaignResultId) {
                // feedback sent successfully
                this.feedbackSent = true;
                window.setTimeout(() => {
                    this.close();
                }, 3000);
            } else {
                // something went wrong
                this.close();
                storeHelper.siteStore.setSnackBarMessage(this.$t("general.messages.error").toString(), true);
            }
        },
        close() {
            this.showFeedback = false;
            this.rating = null;
            this.reaction = "";
        },
        async setShown(): Promise<void> {
            return UAS.set(`campaign_${this.campaignId}_shown`, "1");
        }
    }
});
